import { render, staticRenderFns } from "./festalNeo.vue?vue&type=template&id=4d791d4e&"
import script from "./festalNeo.vue?vue&type=script&lang=js&"
export * from "./festalNeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports